import { gql } from '@apollo/client';

export const USER_QUERY = gql`
  query User {
    user {
      firstName
      lastName
      onboardingStatus {
        value
      }
    }
  }
`;
